import { render, staticRenderFns } from "./MapWidget.vue?vue&type=template&id=568f2dce&scoped=true&"
import script from "./MapWidget.vue?vue&type=script&lang=ts&"
export * from "./MapWidget.vue?vue&type=script&lang=ts&"
import style0 from "./MapWidget.vue?vue&type=style&index=0&id=568f2dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f2dce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
